define(
  'app/takhfifan',[
    'app/setup', 'app/views/base_view','app/views/ga_helper_view', 'app/models/sale', 'app/models/timer',
    'app/views/sale_view', 'app/views/timer_view', 'app/views/google_map_view',
    'app/views/cart_view', 'app/views/discount_coupon_view', 'app/views/login_menu_view',
    'app/views/login_form_view', 'app/views/register_form_view',
    'app/views/checkout_header_view', 'app/views/login_register_view',
    'app/views/shipping_view', 'app/views/payment_view',
    'app/views/success_view', 'app/factories/all',
    'app/views/landing_page_view', 'app/views/city_page_view',
    'app/views/customer_register_success_view', 'app/routers/router', 'app/session'
  ], function(
    takhfifan, baseView, gaHelperView, sale, timer, saleView, timerView, GoogleMapView, cartView,
    discountCouponView, loginMenuView, loginFormView, registerFormView, checkoutHeaderView,
    loginRegisterView, shippingView, paymentView, successView, all_factories,
    landingPageView, cityPageView, customerRegisterSuccessView, router, session
  ) {
    $(function($) {
      if ($('#tmap').length > 0) {
        new takhfifan.GoogleMapView({el: $('#tmap')});
      }

      //init router
      Backbone.history.start({pushState: false, root: Backbone.history.location.pathname});

      //init user session
      session.loadSession();
    });
  }
);

